﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class TimeZoneClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getSystemTimeZones() {
        return this.client.apiTimezonesGet();
    }
}
exports.TimeZoneClient = TimeZoneClient;
//# sourceMappingURL=TimeZoneClient.js.map